// extracted by mini-css-extract-plugin
module.exports = {"Quiz":"Quiz_Quiz__1KSg-","wrapper":"Quiz_wrapper__3oZiy","title":"Quiz_title__1lgzn"};